var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.parsedLinks
    ? _c(
        "ul",
        { staticClass: "links" },
        _vm._l(_vm.parsedLinks, function (link, index) {
          return _c("li", { key: index }, [
            _c("span", [
              link.label
                ? _c("h5", { domProps: { innerHTML: _vm._s(link.label) } })
                : _vm._e(),
              _vm._v(" "),
              link.description
                ? _c("caption", {
                    domProps: { innerHTML: _vm._s(link.description) },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "span",
              [
                link.cta
                  ? _c("secondary-button", {
                      attrs: {
                        label:
                          link.type === "file"
                            ? link.cta.url
                              ? "Download " + _vm.getFileExtension(link.cta.url)
                              : "Download File"
                            : link.cta.target === "_blank"
                            ? "External Link"
                            : "View",
                        link: link.cta.url,
                        theme: "dark",
                        type: link.type,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }